import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { capturePageview, ensureAnalyticsReady } from "./posthog-client";

/**
 * Loads PostHog after the app is interactive, never during render or on the
 * critical path. Gating (env flag, remote kill switch, idle scheduling) lives
 * in posthog-client.ts so identify()/trackEvent() share the exact same
 * readiness check instead of racing it.
 *
 * Also emits $pageview on route changes: the slim bundle only captures the one
 * for the initial load, so without this every path and drop-off query describes
 * landing pages and nothing else.
 */
export const useAnalyticsInit = () => {
  const { pathname, search } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    ensureAnalyticsReady();
  }, []);

  useEffect(() => {
    const path = `${pathname}${search}`;
    // The SDK already sent one for the first path; sending it again would
    // double every landing page in the funnel.
    if (lastPath.current === null) {
      lastPath.current = path;
      return;
    }
    if (lastPath.current === path) return;
    lastPath.current = path;
    capturePageview();
  }, [pathname, search]);
};
